<template>
  <div class="container">
    <van-empty description="提交成功" v-if="this.connectStatus === '3'" />
    <van-empty image="error" description="错误信息" v-if="this.connectStatus === '1'" />
    <van-empty image="network" description="接口异常" v-if="this.connectStatus === '2'" />
    <!-- 正确显示 -->
    <van-form v-if="this.connectStatus === '0'">
      <van-cell-group>
        <van-button type="info" size="mini" @click="getAppraisalOrderDetailInfo">刷新订单</van-button>
        <van-field v-model="this.appraisalResultForm.oaid" label="鉴定号" :disabled="true" required input-align="right" />
        <van-field v-model="this.appraisalResultForm.kindName" label="品类" :disabled="true" required input-align="right" />
        <van-field v-model="this.appraisalResultForm.brandName" label="品牌" :disabled="true" required input-align="right" />
        <van-field v-model="this.appraisalResultForm.genuine" label="AI鉴别结果" :disabled="true" required input-align="right" />
      </van-cell-group>

      <van-image v-if="appraisalResultForm.image" class="img" width="200px" fit="contain" :src="appraisalResultForm.image" @click="showImage(appraisalResultForm.image)" />

      <div v-for="(item, index) in this.appraisalResultForm.appraisalPointItem" :key="index">
        <van-divider content-position="left" :style="{ color: '#000', borderColor: '#1989fa' }" class="word-spacing">
          {{item.pointName + ' ' + 'AI鉴定分数:' + item.grade}}
        </van-divider>
        <van-image class="img" width="200px" fit="contain" :src="item.image" @click="showImage(item.image)" />
      </div>
      <van-divider content-position="left" :style="{ color: '#000', borderColor: '#1989fa' }">最终结果</van-divider>
      <van-radio-group style="margin-bottom: 20px" v-model="appraisalResultForm.appraisalResult" :disabled="isEdited">
        <div style="display: flex; justify-content: space-around;">
          <van-radio :name="1">鉴别通过</van-radio>
          <van-radio :name="2">鉴别不通过</van-radio>
          <van-radio :name="3">无法鉴别</van-radio>
        </div>
      </van-radio-group>
      <van-button round block type="info" native-type="submit" :disabled="isEdited" @click="submitBtnClick">
        提交
      </van-button>
    </van-form>
  </div>
</template>
<script>

const genuineMapper = {
  0: '鉴别不通过',
  1: '鉴别通过',
  2: '无法鉴别',
}

import { Toast, ImagePreview } from "vant";
import {
  appraisal_info,
  oa_to_manual
} from "@/common/api/appraisal.js";
export default {
  name: "cantAppriseToManualOrderDetail",
  data() {
    return {
      isEdited: false,
      connectStatus: "0", // 数据连接状况，默认为0，正常连接 , 1:接口返回错误信息，2：接口连接异常, 3:鉴定提交成功
      showAppraisarResultPicker: false, //选择鉴定结果框
      index: "", //鉴定点索引
      appraisalResultForm: {}, //鉴定结果表单
      // 复核单 ai 鉴定信息，待复核
      aiOrderDetailInfo: null,
      editCacheForm: {
        suggestion: '',
        result: ''
      },
    };
  },
  created () {
    this.getAppraisalOrderDetailInfo();
  },
  methods: {
    //获取鉴定订单详情信息
    getAppraisalOrderDetailInfo () {
      appraisal_info({ oaid: this.$route.query.moaid })
        .then((res) => {
          if (res.errorMsg === "Success") {
            this.connectStatus = "0";
            this.appraisalResultForm = { 
              ...res,
              genuine: genuineMapper[res.genuine]
            }
            this.isEdited = !!res.appraisalResult
          } else {
            this.connectStatus = "1";
          }
        }).catch((err) => {
          console.log('err ----- > ', err)
          this.connectStatus = "2";
        });
    },
    //提交按钮点击
    async submitBtnClick () {
      oa_to_manual({
        oaid: this.$route.query.moaid,
        appraisalResult: this.appraisalResultForm.appraisalResult
      }).then((res) => {
        if (res.errorMsg === "success") {
          this.connectStatus = "3";
        } else {
          Toast.fail({ duration: 1000, message: res.errorMsg });
        }
      });
    },

    // 图片放大查看
    showImage(imgUrl) {
      ImagePreview({
        images: [imgUrl],
        closeable: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f7f8fa;
  justify-content: center;
}
.img{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.word-spacing{
  word-spacing: 3em;
}
</style>
